import styled, { css } from 'styled-components';

const filterRowCountVariants = {
  selected: css`
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED} !important;
    font-family: ${({ theme }) => theme.FONT.REGULAR} !important;
  `
};

export const FilterWrapper = styled.div`
  align-self: flex-start;
  position: sticky;
  top: 62px;
  margin: 6px 12px 6px 0px;
`;

export const FilterRowWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const FilterRowLastChild = styled.div`
  ${({ selected }) => (selected ? filterRowCountVariants.selected : '')}
`;
